export class PaymentTypeModel {
    public cod: string;
    public description: string;
    public value: number;
}
